/**
 * CYCLE-SORT-BUTTON
 * Un seul bouton de tri : son icone montre le tri actif, un clic passe au suivant
 */
import ListButton from "@/components/list-button"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"

interface Item {
  key: string
  name: string //"Trier par ..."
  icon: IconDefinition
}

interface Props<T extends Item> {
  items: T[]
  activeKey: string | null
  onChange: (item: T) => void
}

export default function CycleSortButton<T extends Item>({ items, activeKey, onChange }: Props<T>) {
  const activeIndex = Math.max(0, items.findIndex((item) => item.key === activeKey))
  const active = items[activeIndex]
  const next = items[(activeIndex + 1) % items.length]

  return (
    <ListButton
      tooltipPosition="left"
      isPrimary
      icon={active.icon}
      text={`${active.name} (cliquer pour ${next.name.toLowerCase()})`}
      onClick={() => onChange(next)}
    />
  )
}
